/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "lbieraħ",
      "0": "illum",
      "1": "għada",
      "future": {
        "few": "fi żmien {0} ġranet oħra",
        "many": "fi żmien {0}-il ġurnata oħra",
        "one": "fi żmien ġurnata",
        "other": "fi żmien {0} ġurnata oħra",
        "two": "fi żmien jumejn oħra"
      },
      "past": {
        "few": "{0} ġranet ilu",
        "many": "{0}-il ġurnata ilu",
        "one": "ġurnata ilu",
        "other": "{0} ġurnata ilu",
        "two": "jumejn ilu"
      }
    },
    "day-narrow": {
      "-1": "lbieraħ",
      "0": "illum",
      "1": "għada",
      "future": {
        "few": "fi żmien {0} ġurnata oħra",
        "many": "fi żmien {0}-il ġurnata oħra",
        "one": "fi żmien ġurnata",
        "other": "fi żmien {0} ġurnata oħra",
        "two": "fi żmien jumejn oħra"
      },
      "past": {
        "few": "{0} ġranet ilu",
        "many": "{0}-il ġurnata ilu",
        "one": "ġurnata ilu",
        "other": "{0} ġurnata ilu",
        "two": "jumejn ilu"
      }
    },
    "day-short": {
      "-1": "lbieraħ",
      "0": "illum",
      "1": "għada",
      "future": {
        "few": "fi żmien {0} ġranet oħra",
        "many": "fi żmien {0}-il ġurnata oħra",
        "one": "fi żmien ġurnata",
        "other": "fi żmien {0} ġurnata oħra",
        "two": "fi żmien jumejn oħra"
      },
      "past": {
        "few": "{0} ġranet ilu",
        "many": "{0}-il ġurnata ilu",
        "one": "ġurnata ilu",
        "other": "{0} ġurnata ilu",
        "two": "jumejn ilu"
      }
    },
    "hour": {
      "0": "din is-siegħa",
      "future": {
        "few": "fi żmien {0} sigħat",
        "many": "fi żmien {0}-il siegħa",
        "one": "fi żmien siegħa oħra",
        "other": "fi żmien {0} siegħa",
        "two": "fi żmien sagħtejn"
      },
      "past": {
        "few": "{0} sigħat ilu",
        "many": "{0}-il siegħa ilu",
        "one": "siegħa ilu",
        "other": "{0} siegħa ilu",
        "two": "sagħtejn ilu"
      }
    },
    "hour-narrow": {
      "0": "din is-siegħa",
      "future": {
        "few": "fi żmien {0} sigħat",
        "many": "fi żmien {0}-il siegħa",
        "one": "fi żmien siegħa oħra",
        "other": "fi żmien {0} siegħa",
        "two": "fi żmien sagħtejn"
      },
      "past": {
        "few": "{0} sigħat ilu",
        "many": "{0}-il siegħa ilu",
        "one": "siegħa ilu",
        "other": "{0} siegħa ilu",
        "two": "sagħtejn ilu"
      }
    },
    "hour-short": {
      "0": "din is-siegħa",
      "future": {
        "few": "fi żmien {0} sigħat",
        "many": "fi żmien {0}-il siegħa",
        "one": "fi żmien siegħa oħra",
        "other": "fi żmien {0} siegħa",
        "two": "fi żmien sagħtejn"
      },
      "past": {
        "few": "{0} sigħat ilu",
        "many": "{0}-il siegħa ilu",
        "one": "siegħa ilu",
        "other": "{0} siegħa ilu",
        "two": "sagħtejn ilu"
      }
    },
    "minute": {
      "0": "din il-minuta",
      "future": {
        "few": "sa {0} minuti oħra",
        "many": "sa {0}-il minuta oħra",
        "one": "sa minuta oħra",
        "other": "sa {0} minuta oħra",
        "two": "sa {0} minuti oħra"
      },
      "past": {
        "few": "{0} minuti ilu",
        "many": "{0}-il minuta ilu",
        "one": "minuta ilu",
        "other": "{0} minuta ilu",
        "two": "{0} minuti ilu"
      }
    },
    "minute-narrow": {
      "0": "din il-minuta",
      "future": {
        "few": "sa {0} min. oħra",
        "many": "sa {0}-il min",
        "one": "sa min. oħra",
        "other": "sa {0} min. oħra",
        "two": "sa {0} min. oħra"
      },
      "past": {
        "few": "{0} min. ilu",
        "many": "{0}-il min. ilu",
        "one": "min. ilu",
        "other": "{0} min. ilu",
        "two": "{0} min. ilu"
      }
    },
    "minute-short": {
      "0": "din il-minuta",
      "future": {
        "few": "sa {0} min. oħra",
        "many": "sa {0}-il min. oħra",
        "one": "sa min. oħra",
        "other": "sa {0} min. oħra",
        "two": "sa {0} min. oħra"
      },
      "past": {
        "few": "{0} min. ilu",
        "many": "{0}-il min. ilu",
        "one": "min. ilu",
        "other": "{0} min. ilu",
        "two": "{0} min. ilu"
      }
    },
    "month": {
      "-1": "ix-xahar li għadda",
      "0": "dan ix-xahar",
      "1": "ix-xahar id-dieħel",
      "future": {
        "few": "fi {0} xhur oħra",
        "many": "fi {0}-xahar oħra",
        "one": "sa xahar ieħor",
        "other": "fi {0} xahar oħra",
        "two": "fi xahrejn oħra"
      },
      "past": {
        "few": "{0} xhur ilu",
        "many": "{0}-il xahar ilu",
        "one": "xahar ilu",
        "other": "{0} xahar ilu",
        "two": "xahrejn ilu"
      }
    },
    "month-narrow": {
      "-1": "ix-xahar li għadda",
      "0": "dan ix-xahar",
      "1": "ix-xahar id-dieħel",
      "future": {
        "few": "sa {0} xhur oħra",
        "many": "sa {0}-il xahar oħra",
        "one": "sa xahar ieħor",
        "other": "sa {0} xahar oħra",
        "two": "sa xahrejn oħra"
      },
      "past": {
        "few": "{0} xhur ilu",
        "many": "{0}-il xahar ilu",
        "one": "xahar ilu",
        "other": "{0} xahar ilu",
        "two": "xahrejn ilu"
      }
    },
    "month-short": {
      "-1": "ix-xahar li għadda",
      "0": "dan ix-xahar",
      "1": "ix-xahar id-dieħel",
      "future": {
        "few": "sa {0} xhur oħra",
        "many": "sa {0}-il xahar oħra",
        "one": "sa xahar ieħor",
        "other": "sa {0} xahar oħra",
        "two": "sa xahrejn oħra"
      },
      "past": {
        "few": "{0} xhur ilu",
        "many": "{0}-il xahar ilu",
        "one": "{0} xahar ilu",
        "other": "{0} xahar ilu",
        "two": "xahrejn ilu"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "il-kwart ta’ sena li għadda",
      "0": "il-kwart ta’ sena li qegħdin fih",
      "1": "il-kwart li jmiss tas-sena",
      "future": {
        "few": "f’{0} kwarti ta’ sena oħrajn",
        "many": "f’{0}-il kwart ta’ sena oħrajn",
        "one": "f’{0} kwart ta’ sena oħrajn",
        "other": "f’{0} kwart ta’ sena oħrajn",
        "two": "f’{0} kwarti ta’ sena oħrajn"
      },
      "past": {
        "few": "{0} kwarti ta’ sena li għaddew",
        "many": "{0}-il kwart ta’ sena li għaddew",
        "one": "il-kwart ta’ sena li għadda",
        "other": "{0} kwart ta’ sena li għaddew",
        "two": "{0} kwarti ta’ sena li għaddew"
      }
    },
    "quarter-narrow": {
      "-1": "il-kwart ta’ sena li għadda",
      "0": "il-kwart ta’ sena li qegħdin fih",
      "1": "il-kwart li jmiss tas-sena",
      "future": {
        "few": "f’{0} kwarti ta’ sena oħrajn",
        "many": "f’{0}-il kwart ta’ sena oħrajn",
        "one": "fi kwart ta’ sena ieħor",
        "other": "f’{0} kwart ta’ sena oħrajn",
        "two": "f’{0} kwarti ta’ sena oħrajn"
      },
      "past": {
        "few": "{0} kwarti ta’ sena ilu",
        "many": "{0}-il kwart ta’ sena ilu",
        "one": "fil-kwart tas-sena li għadda",
        "other": "{0} kwart ta’ sena ilu",
        "two": "{0} kwarti ta’ sena ilu"
      }
    },
    "quarter-short": {
      "-1": "il-kwart ta’ sena li għadda",
      "0": "il-kwart ta’ sena li qegħdin fih",
      "1": "il-kwart li jmiss tas-sena",
      "future": {
        "few": "f’{0} kwarti ta’ sena oħrajn",
        "many": "f’{0}-il kwart ta’ sena oħrajn",
        "one": "fil-kwart tas-sena li ġej",
        "other": "f’{0} kwart ta’ sena oħrajn",
        "two": "f’{0} kwarti ta’ sena oħrajn"
      },
      "past": {
        "few": "{0} kwarti ta’ sena ilu",
        "many": "{0}-il kwart ta’ sena ilu",
        "one": "fil-kwart tas-sena li għadda",
        "other": "{0} kwart ta’ sena ilu",
        "two": "{0} kwarti ta’ sena ilu"
      }
    },
    "second": {
      "0": "issa",
      "future": {
        "few": "sa {0} sekondi oħra",
        "many": "sa {0}-il sekonda oħra",
        "one": "sa sekonda oħra",
        "other": "sa {0} sekonda oħra",
        "two": "sa {0} sekondi oħra"
      },
      "past": {
        "few": "{0} sekondi ilu",
        "many": "{0}-il sekonda ilu",
        "one": "sekonda ilu",
        "other": "{0} sekonda ilu",
        "two": "{0} sekondi ilu"
      }
    },
    "second-narrow": {
      "0": "issa",
      "future": {
        "few": "sa {0} sek. oħra",
        "many": "sa {0}-il sek. oħra",
        "one": "sa sek. oħra",
        "other": "sa {0} sek. oħra",
        "two": "sa {0} sek. oħra"
      },
      "past": {
        "few": "{0} sek. ilu",
        "many": "{0}-il sek. ilu",
        "one": "sek. ilu",
        "other": "{0} sek. ilu",
        "two": "{0} sek. ilu"
      }
    },
    "second-short": {
      "0": "issa",
      "future": {
        "few": "sa {0} sek. oħra",
        "many": "sa {0}-il sek. oħra",
        "one": "sa sek. oħra",
        "other": "sa {0} sek. oħra",
        "two": "sa {0} sek. oħra"
      },
      "past": {
        "few": "{0} sek. ilu",
        "many": "{0}-il sek. ilu",
        "one": "sek. ilu",
        "other": "{0} sek. ilu",
        "two": "{0} sek. ilu"
      }
    },
    "week": {
      "-1": "il-ġimgħa li għaddiet",
      "0": "din il-ġimgħa",
      "1": "il-ġimgħa d-dieħla",
      "future": {
        "few": "sa {0} ġimgħat oħra",
        "many": "sa {0}-il ġimgħa oħra",
        "one": "sa ġimgħa oħra",
        "other": "sa {0} ġimgħa oħra",
        "two": "sa ġimagħtejn oħra"
      },
      "past": {
        "few": "{0} ġimgħat ilu",
        "many": "{0}-il ġimgħa ilu",
        "one": "ġimgħa ilu",
        "other": "{0} ġimgħa ilu",
        "two": "ġimagħtejn ilu"
      }
    },
    "week-narrow": {
      "-1": "il-ġimgħa li għaddiet",
      "0": "din il-ġimgħa",
      "1": "il-ġimgħa d-dieħla",
      "future": {
        "few": "sa {0} ġimgħat oħra",
        "many": "sa {0}-il ġimgħa oħra",
        "one": "sa ġimgħa oħra",
        "other": "sa {0} ġimgħa oħra",
        "two": "sa ġimagħtejn oħra"
      },
      "past": {
        "few": "{0} ġimgħat ilu",
        "many": "{0}-il ġimgħa ilu",
        "one": "ġimgħa ilu",
        "other": "{0} ġimgħa ilu",
        "two": "ġimagħtejn ilu"
      }
    },
    "week-short": {
      "-1": "il-ġimgħa li għaddiet",
      "0": "din il-ġimgħa",
      "1": "il-ġimgħa d-dieħla",
      "future": {
        "few": "sa {0} ġimgħat oħra",
        "many": "sa {0}-il ġimgħa oħra",
        "one": "sa ġimgħa oħra",
        "other": "sa {0} ġimgħa oħra",
        "two": "sa ġimagħtejn oħra"
      },
      "past": {
        "few": "{0} ġimgħat ilu",
        "many": "{0}-il ġimgħa ilu",
        "one": "ġimgħa ilu",
        "other": "{0} ġimgħa ilu",
        "two": "ġimagħtejn ilu"
      }
    },
    "year": {
      "-1": "is-sena l-oħra",
      "0": "din is-sena",
      "1": "is-sena d-dieħla",
      "future": {
        "few": "fi żmien {0} snin oħra",
        "many": "fi żmien {0}-il sena oħra",
        "one": "fi żmien sena",
        "other": "fi żmien {0} sena oħra",
        "two": "fi żmien sentejn oħra"
      },
      "past": {
        "few": "{0} snin ilu",
        "many": "{0}-il sena ilu",
        "one": "sena ilu",
        "other": "{0} sena ilu",
        "two": "sentejn ilu"
      }
    },
    "year-narrow": {
      "-1": "is-sena l-oħra",
      "0": "din is-sena",
      "1": "is-sena d-dieħla",
      "future": {
        "few": "fi żmien {0} snin oħra",
        "many": "fi żmien {0}-il sena oħra",
        "one": "fi żmien sena",
        "other": "fi żmien {0} sena oħra",
        "two": "fi żmien sentejn oħra"
      },
      "past": {
        "few": "{0} snin ilu",
        "many": "{0}-il sena ilu",
        "one": "sena ilu",
        "other": "{0} sena ilu",
        "two": "sentejn ilu"
      }
    },
    "year-short": {
      "-1": "is-sena l-oħra",
      "0": "din is-sena",
      "1": "is-sena d-dieħla",
      "future": {
        "few": "fi żmien {0} snin oħra",
        "many": "fi żmien {0}-il sena oħra",
        "one": "fi żmien sena",
        "other": "fi żmien {0} sena oħra",
        "two": "fi żmien sentejn oħra"
      },
      "past": {
        "few": "{0} snin ilu",
        "many": "{0}-il sena ilu",
        "one": "sa sena ilu",
        "other": "{0} sena ilu",
        "two": "sentejn ilu"
      }
    }
  },
  "locale": "mt"
})
}
